import { logOut, updateLocalStorageToken } from "../../../../containers/resources/utils";
import HotelierService from "../../../../services/catalogs/HotelierService";

export const REQUEST_DELETE_HOTELIER = "REQUEST_DELETE_HOTELIER";
export const DELETE_HOTELIER_SUCCESS = "DELETE_HOTELIER_SUCCESS";
export const DELETE_HOTELIER_ERROR = "DELETE_HOTELIER_ERROR";

function requestDeleteHotelier() {
  return {
    type: REQUEST_DELETE_HOTELIER,
  };
}

function deleteHotelierSuccess(json) {
  return {
    type: DELETE_HOTELIER_SUCCESS,
    message: json.data,
  };
}

function deleteHotelierError(json) {
  return {
    type: DELETE_HOTELIER_ERROR,
    error: json.data,
  };
}

export function deleteHotelier(hotelier_id) {
  return (dispatch) => {
    dispatch(requestDeleteHotelier());
    return HotelierService.deleteHotelier(hotelier_id).then((json) => {
      if (json.data.code === 200) {
        dispatch(deleteHotelierSuccess(json.data));
      } else if (json.data.code === 202) {
        updateLocalStorageToken(json.data.token);
        dispatch(deleteHotelier(hotelier_id));
      } else if (json.data.code === 498) {
        logOut();
      } else {
        dispatch(deleteHotelierError(json.data));
      }
    });
  };
}
